import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { PartialProduct } from '../interfaces/PartialProduct';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  constructor(private http: HttpClient) { }

  getAllOrders(): Observable<any> {
    return this.http.get(environment.Server_URL + '/orders');
  }
  getOrderByUserId(id: string, page: any): Observable<any> {
    return this.http.get(environment.Server_URL + '/orderuser/' + id + `?page=${page}`);
  }
  getOrderById(orderId: number): Observable<any> {
    return this.http.get(`${environment.Server_URL}/orders/${orderId}`);
  }

  deleteOrder(id: string): Observable<any> {
    return this.http.delete(environment.Server_URL + '/orders/' + id);
  }

  addCommentInOrder(id: any, comment: any): Observable<any> {
    const body = new FormData();
    body.append('comment', comment);
    return this.http.post(`${environment.Server_URL}/update/comment/` + id, body);
  }
  changeStatus(id: any, status: any, reason: any): Observable<any> {
    const body = new FormData();
    body.append('order_status', status);
    body.append('reason', reason);
    return this.http.post(`${environment.Server_URL}/updatestatus/` + id, body);
  }
  updateQty(status: any, orderid: any): Observable<any> {
    const body = new FormData();
    body.append('order_status', status);
    body.append('order_id', orderid);
    return this.http.post(`${environment.Server_URL}/orders/reject`, body);
  }
  paymentRequest(id: any): Observable<any> {

    return this.http.get(environment.Server_URL + '/update/reuested/' + id);
  }
  getOrders(perpage: any, page: any): Observable<any> {
    const body = new FormData();
    body.append('per_page', perpage);
    return this.http.post(`${environment.Server_URL}/get/pag/order?page=${page}`, body);
  }
  searchOrders(searchKey: any, warehouseId: any, userId?: any): Observable<any> {
    const body = new FormData();

    if (searchKey) {
      body.append('phone_number', searchKey);
    }

    body.append('warehouse_id', warehouseId.toString());

    if (userId) {
      body.append('user_id', userId.toString());
    }

    return this.http.post(
      `${environment.Server_URL}/stocks/search/order`,
      body
    );
  }


  addOrder(formData: FormData): Observable<any> {
    return this.http.post(
      `${environment.Server_URL}/orders`,
      formData
    );
  }
  addDeliveryHero(id: any, delivery_hero: any): Observable<any> {
    const body = new FormData();
    body.append('order_id', id);
    body.append('delivery_hero', delivery_hero);
    return this.http.post(`${environment.Server_URL}/update-delivery-hero`, body);
  }
  getStocksData(id: any): Observable<any> {
    return this.http.get(environment.Server_URL + '/warehouses/all/data/' + id);
  }
  adddiscountOrTotalOrIcome(orderId: any, total: string, income: string, discount: string): Observable<any> {
    const body = new FormData();
    body.append('total', total);
    body.append('income', income);
    body.append('discount', discount);
    return this.http.post(`${environment.Server_URL}/orders/${orderId}/financials`, body);
  }

  updateDeliveryHero(orderId: number, deliveryHeroId: number) {
    const body = {
      deliveryhero_id: deliveryHeroId
    };

    return this.http.post(`${environment.Server_URL}/orders/${orderId}/update-deliveryhero`, body);
  }
  getDeliveryHeroesOrders(deliveryhero_id: any, page: any): Observable<any> {
    return this.http.get(`${environment.Server_URL}/orders/by-delivery-hero`, {
      params: {
        deliveryhero_id: deliveryhero_id,
        page: page,
        per_page: 10
      }
    });
  }
  updateDeliveryStatus(orderId: number, status: number): Observable<any> {
    return this.http.post(`${environment.Server_URL}/orders/${orderId}/update-delivery-status`, {
      delivery_status: status.toString()
    });
  }

  updateOrder(orderId: number, orderData: any) {
    return this.http.put(`${environment.Server_URL}/orders/update/${orderId}`, orderData);
  }
  updateQuantityIncomeTotal(
    orderId: number,
    quantity: number[],
    bonuses?: any[],
    duenow?: string,
    total?: string
  ): Observable<any> {
    const body = {
      quantity: quantity,
      bonuses: bonuses,   // ✅ إضافة البونص هنا
      duenow: duenow,
      total: total
    };

    return this.http.put(
      `${environment.Server_URL}/orders/update-quantity-income-total/${orderId}`,
      body
    );
  }

  updatePartialFlag(orderId: number, isPartiallyCompleted: boolean): Observable<any> {
    const url = `${environment.Server_URL}/orders/${orderId}/update-partial-flag`;
    const body = {
      ispartially_completed: isPartiallyCompleted
    };
    return this.http.put(url, body);
  }

  getOrdersByWarehouseId(warehouseId: number, page: number, perPage?: number): Observable<any> {
    const params: any = { page: String(page) };

    if (perPage !== undefined && perPage !== null) {
      params.per_page = String(perPage);
    }

    return this.http.get(`${environment.Server_URL}/orders/warehouse/${warehouseId}`, { params });
  }

  getOrdersTotalsByDate(filters: {
    warehouse_id: number | string;
    day?: number | string | null;
    month?: number | string | null;
    year?: number | string | null;
    withorders?: boolean | number | string | null;
  }): Observable<any> {
    const params: any = {
      warehouse_id: String(filters.warehouse_id),
    };

    if (filters.day !== null && filters.day !== undefined && filters.day !== '') {
      params.day = String(filters.day);
    }

    if (filters.month !== null && filters.month !== undefined && filters.month !== '') {
      params.month = String(filters.month);
    }

    if (filters.year !== null && filters.year !== undefined && filters.year !== '') {
      params.year = String(filters.year);
    }

    if (filters.withorders !== null && filters.withorders !== undefined && filters.withorders !== '') {
      params.withorders = String(filters.withorders);
    }

    return this.http.get<any>(
      `${environment.Server_URL}/orders/totals-by-date`,
      { params }
    );
  }

  updatePaymentType(orderId: number, paymentType?: number, paid?: number, remaining?: number): Observable<any> {
    const body: any = {};

    if (paymentType !== undefined) {
      body.payment_type = paymentType;
    }
    if (paid !== undefined) {
      body.paid = paid;
    }
    if (remaining !== undefined) {
      body.remaining = remaining;
    }

    return this.http.put(`${environment.Server_URL}/orders/${orderId}/payment-type`, body);
  }

  getOrderByWarehouse(warehouseId: number, orderId: number): Observable<any> {
    return this.http.post(`${environment.Server_URL}/orders/get-by-warehouse`, {
      warehouse_id: warehouseId,
      order_id: orderId
    });
  }
  filterOrders(warehouseId: number, filterBy: string, filterValue?: any, page: number = 1, perPage: number = 10) {
    return this.http.get<any>(`${environment.Server_URL}/orders/filter`, {
      params: {
        warehouse_id: warehouseId.toString(),
        filter_by: filterBy,
        filter_value: filterValue,
        page: page.toString(),
        per_page: perPage.toString(),
      }
    });
  }

  generateLinkQr(link: string, orderId: number) {
    return this.http.post(`${environment.Server_URL}/qrcodes/link`, {
      link: link,
      order_id: orderId,
    });
  }
  getQrByOrderId(orderId: number) {
    return this.http.get(`${environment.Server_URL}/qrcodes/order/${orderId}`);
  }

  markQrAsUsed(orderId: number) {
    return this.http.post(`${environment.Server_URL}/qrcodes/order/${orderId}/mark-used`, {});
  }
  getByIds(ids: number[]) {
    return this.http.post(`${environment.Server_URL}/stocks/by-ids`, {
      ids: ids
    });
  }
  getClientById(clientId: number): Observable<any> {
    return this.http.get(`${environment.Server_URL}/clients/${clientId}`);
  }
  // ===== Today Orders APIs =====

  // ترجع آخر 10 today_orders (زي ما ظبطنا index في الكونترولر)
  getTodayOrders(): Observable<any> {
    return this.http.get(`${environment.Server_URL}/today-orders`);
  }

  // إنشاء today_order جديد (name + array of orders_ids)
  createTodayOrder(name: string, ordersIds: number[]): Observable<any> {
    return this.http.post(`${environment.Server_URL}/today-orders`, {
      name: name,
      orders_ids: ordersIds
    });
  }
  // ✅ تجيب أوردرز بالـ IDs (Orders By Ids)
  getOrdersByIds(ids: number[]): Observable<any> {
    return this.http.post(`${environment.Server_URL}/orders/by-ids`, {
      ids: ids
    });
  }

}
